// removed by extract-text-webpack-plugin
module.exports = {"contentPlaceholder":"_2kbKJEFJUNMTySjRfNRDI","content":"_2krqlQmd6dvfub7WWaIXzk","h1":"_1crrCKlKOAuDbeK47YoRaC","header":"_1alni_bS6xiNTEYFPCVy6W","container":"_1NFzVF18llO68FOpC1bBr"};


//////////////////
// WEBPACK FOOTER
// ./src/css/_layout.scss
// module id = 7
// module chunks = 0